<template>
  <PageHeader :showBreadcrumb="true" />
  <p>
    Under Minnesota Statue §62D.08 Subd. 2. Annual reporting is required from every health maintenance organization (HMO).
    Currently, there are four reports that are required each year: Statement of Revenue, Complaint Category Reporting, and Reallocation of Expenses and Investment Income are all due by April 1st.
    Enrollment reporting is due July 1st.
  </p>
  <p>
    To view the forms that must be uploaded, see <a href="https://www.health.state.mn.us/facilities/insurance/managedcare/annualreporting.html">HMO Annual Reporting - MN Dept. of Health</a>.
    You need to contact MDH to notify about your upload, if you are filing after the due date.
  </p>
  <p>
    * All Uploads must be in .xlsx or .xlsm format except for Enrollment Attestation Document
  </p>
  <hr/>
  <div class="container text-center">
    <div class="row mb-2 g-3">
      <div class="col-lg-12 col-md-12">
        <FormSelectGroup v-if="userEntityAssigned"
                         label="Select Entity"
                         inputId="entity-input"
                         :required="true"
                         state>
          <template #default="">
            <PvSelect id="entity-input"
                      v-model="selectedEntity"
                      :options="userEntityOptions"
                      @change="onChangeEntity"
                      ariaLabel="entity-input-label"
                      placeholder="-- Select Entity --"
                      optionLabel="name"
                      optionValue="id"
                      autoOptionFocus="true"/>
          </template>
        </FormSelectGroup>
      </div>
    </div>
    <hr/>
    <div class="row mb-2 g-3" v-if="selectedEntity">
      <div class="container">
        <h3>April 1st</h3>
        <div class="col-lg-6 col-md-12">
          <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
            <MNFileUpload module-type="Annual Required Filings And Forms" label="Statement of Revenue, Expenses and Net Income (Supplement 1) Upload" ref="statementOfRevenueExpensesAndNetIncome" name="statementOfRevenueExpensesAndNetIncome"  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12" url="/undefined"  :entity="selectedEntity"/>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
            <MNFileUpload module-type="Annual Required Filings And Forms" label="Reallocation of Expenses and Investment Income (Supplement 1a) Upload" ref="reallocationOfExpensesAndInvestmentIncome" name="reallocationOfExpensesAndInvestmentIncome"  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12" url="/undefined" :entity="selectedEntity"/>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
            <MNFileUpload module-type="Annual Required Filings And Forms" label="Complaint Category Reporting Upload" ref="complaintCategoryReporting" name="complaintCategoryReporting" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12" url="/undefined" :entity="selectedEntity"/>
          </div>
        </div>
      </div>
      <div class="container">
        <h3>July 1st</h3>
        <div class="col-lg-6 col-md-12">
          <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
            <MNFileUpload module-type="Annual Required Filings And Forms" label="Enrollment Report (Supplement 6) Upload" ref="enrollment" name="enrollment"  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12" url="/undefined" :entity="selectedEntity"/>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
            <MNFileUpload module-type="Annual Required Filings And Forms" label="Enrollment Attestation Document Upload (only file if no enrollment in Minnesota)" ref="enrollmentAttestationDocument" name="enrollmentAttestationDocument" accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf" url="/undefined" :entity="selectedEntity"/>
          </div>
        </div>
      </div>
      <div class="container">
        <h3>Other Uploads</h3>
        <div class="col-lg-6 col-md-12">
          <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
            <MNFileUpload module-type="Annual Required Filings And Forms" label="Other File Upload" ref="otherFile" name="otherFile" accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf" url="/undefined" :entity="selectedEntity"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
import MNFileUpload from "@/components/common/MNFileUpload.vue";
import FormSelectGroup from "@/components/common/FormSelectGroup.vue";
import {useAppStore} from "@/stores/appStore.js";
import {ENTITY_TYPES} from "@/utils/constants.js";
import {computed, ref} from "vue";

const appStore = useAppStore();
const selectedEntity = ref();

const complaintCategoryReporting = ref();
const enrollment = ref();
const statementOfRevenueExpensesAndNetIncome = ref();
const reallocationOfExpensesAndInvestmentIncome = ref();
const enrollmentAttestationDocument = ref();
const otherFile = ref();

const userEntityOptions = computed(() => {
  return appStore.getUserEntitiesByType(ENTITY_TYPES.HMO);
});

const userEntityAssigned = computed(() => {
  return userEntityOptions.value && userEntityOptions.value.length > 0;
});

const onChangeEntity = async ({originalEvent, value}) => {
  complaintCategoryReporting.value?.clear();
  enrollment.value?.clear();
  statementOfRevenueExpensesAndNetIncome.value?.clear();
  reallocationOfExpensesAndInvestmentIncome.value?.clear();
  enrollmentAttestationDocument.value?.clear();
  otherFile.value?.clear();
};
</script>

<style scoped>

</style>